/**
 * Created by Administrador on 3/24/2017.
 */
(function () {
    'use strict';

    var checkBoxes = {
        templateUrl: 'app/components/checkBox/checkboxes.html',
        controller: checkBoxesController,
        controllerAs: 'vm',
        bindings: {
            inline: '@',
            target: '@',
            label: '@',
            checkBox: '=',
            key: '=',
            ngModel: '=',
            selectCheckbox: '=',
            require: '=',
            isDisabled: '=',
            onChangeEvent: '&'
        }
    };

    angular
        .module('completeAir')
        .component('checkBoxes', checkBoxes);

    checkBoxesController.$inject = ['$timeout'];

    function checkBoxesController($timeout) {
        var vm = this;

        vm.$onInit = function(){
            vm.type = (vm.inline === undefined) ? "block" : "inline";
            vm.isDisabled = (vm.isDisabled === undefined) ? false : vm.isDisabled;
        }

        vm.someSelected = function (object) {
            return Object.keys(object).some(function (key) {
                return object[key];
            });
        }

        vm.handleChangeEvent = function(){
            $timeout(function () {
                vm.onChangeEvent({checkBox: vm.checkBox, key: vm.key});
            });
        }
    }
})();
